import { PlanktonProductConfig } from './PlanktonProductConfig';

const certCalkinsProductConfig: PlanktonProductConfig = {
  planktonVersionPrefix: 'onecms/:PRODUCT_ID',
  edsLtiRceToolId: '2ad55c2f-39e7-46fa-8c1f-f5035e473f73',
  edsLtiVideoToolId: '02ee8e37-5c5b-48f5-806c-16e8e3dad55a',
};

export default certCalkinsProductConfig;
